import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';

import AllCollection from './components/AllFinancials';
import PendingCollection from './components/PendingFinancials';
import LogsCollection from './components/LogsFinancials';
import WorkOrders from "./components/WorkOrders";
import AuditWorkOrders from "./components/AuditWorkOrders";
import FieldEngineerWeeklyAudit from "./components/FieldEngineerWeeklyAudit";
import Object from './components/Financial';
import UserRoles from "constants/UserRoles";

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';

/*
	First is exact Route XYZ/
	Second is sub page(s) XYZ/ABC
	Third is sub page(s) with IDs XYZ/ABC/ID
	Last is non exact with ID. XYZ/ID
	Final is a redirect
 */
export default ({match, regions, roles}) => (
	<div>
		<Switch>
			{roles.some(role => [UserRoles.Admin, UserRoles.Manager].includes(role)) &&
				<ErrorBoundaryRoute exact path={`${match.url}`}>
					<AllCollection regions={regions} roles={roles}/>
				</ErrorBoundaryRoute>
			}
			{roles.some(role => [UserRoles.Admin, UserRoles.Manager].includes(role)) &&
				<ErrorBoundaryRoute exact path={`${match.url}/work_orders`}>
					<WorkOrders regions={regions} roles={roles}/>
				</ErrorBoundaryRoute>
			}
			{roles.some(role => [UserRoles.Admin, UserRoles.Manager].includes(role)) &&
				<ErrorBoundaryRoute exact path={`${match.url}/audit_work_orders`}>
					<AuditWorkOrders regions={regions} roles={roles}/>
				</ErrorBoundaryRoute>
			}
			{roles.some(role => [UserRoles.Admin, UserRoles.Financial].includes(role)) &&
				<ErrorBoundaryRoute exact path={`${match.url}/fe_weekly_audit`}>
					<FieldEngineerWeeklyAudit regions={regions} roles={roles}/>
				</ErrorBoundaryRoute>
			}
			{roles.some(role => [UserRoles.Admin, UserRoles.Manager].includes(role)) &&

				<ErrorBoundaryRoute exact path={`${match.url}/pendings`}>
					<PendingCollection regions={regions} roles={roles}/>
				</ErrorBoundaryRoute>
			}
			{roles.some(role => [UserRoles.Admin, UserRoles.Manager].includes(role)) &&
				<ErrorBoundaryRoute exact path={`${match.url}/logs`}>
					<LogsCollection regions={regions} roles={roles}/>
				</ErrorBoundaryRoute>
			}
			{roles.some(role => [UserRoles.Admin, UserRoles.Manager].includes(role)) &&
				<ErrorBoundaryRoute path={`${match.url}/:id`}>
					<Object regions={regions} roles={roles} baseUrl={match.url}/>
				</ErrorBoundaryRoute>
			}

			<ErrorBoundaryRoute path={`${match.url}/:id`}>
				<Object regions={regions} roles={roles} baseUrl={match.url}/>
			</ErrorBoundaryRoute>

			{roles.includes(UserRoles.HelpDesk) && <Redirect to="/helpdesks/cash_check"/>}
			{!roles.includes(UserRoles.HelpDesk) && <Redirect to={`${match.url}`}/>}

		</Switch>
	</div>
);
